import { render, staticRenderFns } from "./breathDevice.vue?vue&type=template&id=08c885e2&scoped=true&"
import script from "./breathDevice.vue?vue&type=script&lang=js&"
export * from "./breathDevice.vue?vue&type=script&lang=js&"
import style0 from "./breathDevice.vue?vue&type=style&index=0&id=08c885e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c885e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c885e2')) {
      api.createRecord('08c885e2', component.options)
    } else {
      api.reload('08c885e2', component.options)
    }
    module.hot.accept("./breathDevice.vue?vue&type=template&id=08c885e2&scoped=true&", function () {
      api.rerender('08c885e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/devices/breathDevice.vue"
export default component.exports